import { Form, Col } from "react-bootstrap";
import RATooltip from "./RATooltip";

export default function FrequencyPicker({ formData, setFormData, name, inputOnly = false }) {
    const frequencyOptions = Array.from({ length: 25 }, (_, i) => i + 1);

    if (!formData.run_frequency) {
        setFormData({
            ...formData,
            run_frequency: 3,
        });
    }

    const input = (
        <Form.Group as={Col} className="col-12 col-xl">
            <Col>
                <Form.Select
                    id={`${name}-frequency-selector`}
                    className=" d-inline-block px-2"
                    value={formData.run_frequency}
                    onChange={e =>
                        setFormData({
                            ...formData,
                            run_frequency: e.target.value,
                        })
                    }
                    min={1}>
                    {frequencyOptions.map(send => (
                        <option key={send} value={send}>
                            every {send} {send === 1 ? "week" : "weeks"}
                        </option>
                    ))}
                </Form.Select>
            </Col>
        </Form.Group>
    );

    if (inputOnly) {
        return input;
    }
    return (
        <div className={`col-xl-${name.toLowerCase().includes("edit") ? 4 : 2}`}>
            <Form.Label className=" text-nowrap">
                Frequency
                <RATooltip className="ms-2">
                    <p>How often the report will be sent.</p>
                </RATooltip>
            </Form.Label>
            {input}
        </div>
    );
}
